/// <reference types="vite/client" />
// Basic wrapper for fetch to interact with the Worker API
const API_URL = import.meta.env.VITE_API_URL || 'http://127.0.0.1:8787';

export const useRaffleApi = () => {
  const get = async (path: string) => {
    const res = await fetch(`${API_URL}${path}`);
    if (!res.ok) throw new Error(`API Error: ${res.statusText}`);
    return res.json();
  };

  const post = async (path: string, body: any) => {
    const res = await fetch(`${API_URL}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    // Handle specific error formats from Hono/Zod
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      let errorMessage = errorData.error || `API Error: ${res.statusText}`;
      if (typeof errorMessage === 'object') {
        errorMessage = JSON.stringify(errorMessage);
      }
      throw new Error(errorMessage);
    }
    return res.json();
  };

  return {
    get,
    post,
    getSorteos: () => get('/raffles'),
    getSorteosCerrados: () => get('/sorteos/closed'),
    getBoletos: (raffleId: string) => get(`/sorteos/${raffleId}/boletos`),
    reserveTickets: (data: any) => post('/ventas/reservar', data),
    reserveManualTickets: (data: any) => post('/ventas/reservar-manual', data),
    createPayment: (orderId: string, amount: number) => post('/pagos/crear', { orderId, amount }),
    searchSales: (query: string) => get(`/ventas/buscar?q=${encodeURIComponent(query)}`),
    getConfig: () => get('/config'),
    // OTP Endpoints
    requestOtp: (email: string) => post('/public/my-tickets-otp', { email }),
    verifyOtp: (email: string, code: string) => post('/public/my-tickets-verify', { email, code }),
    getMyTickets: (token: string) =>
      fetch(`${API_URL}/public/my-tickets`, {
        headers: { Authorization: `Bearer ${token}` },
      }).then((res) => res.json()),
    // Cart Recovery
    saveCart: (data: { session_token: string; items: any[]; contact_info?: any }) =>
      post('/public/cart/save', data),
    loadCart: (token: string) => get(`/public/cart/load?token=${token}`),
  };
};
